import { createIcon } from "@chakra-ui/react";

export const Feather = createIcon({
  displayName: "Feather",
  viewBox: "0 0 24 24",
  path: [
    <g clipPath="url(#79ic1bfxaa)">
      <path
        fill="currentColor"
        d="M13.055 10.106 1.08 22.078a1.124 1.124 0 0 0 1.59 1.589l3.505-3.506c.347.215.717.384 1.115.492 2.1.572 5.368.652 8.555-1.462.572-.38.272-1.191-.412-1.191h-.755a.43.43 0 0 1-.127-.844l4.58-1.373a.71.71 0 0 0 .394-.286c.206-.3.403-.605.59-.919.291-.483-.07-1.078-.632-1.078h-1.81a.43.43 0 0 1-.126-.844l3.792-1.139a.75.75 0 0 0 .478-.436c1.364-3.44 1.988-7.045 2.18-9.356a1.59 1.59 0 0 0-.469-1.247A1.59 1.59 0 0 0 22.28.01C18.352.33 10.711 1.9 6.441 6.17 2.686 9.923 2.658 14.17 3.343 16.706c.098.37.562.45.834.178l7.71-7.706a.753.753 0 0 1 1.06 0 .747.747 0 0 1 .103.928h.005z"
      />
    </g>,
    <defs>
      <clipPath id="79ic1bfxaa">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>,
  ],
  defaultProps: {
    "aria-label": "A feather"
  }
});

export default Feather;
